import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Truck, ArrowLeft } from "@phosphor-icons/react";
import { toast, Toaster } from "sonner";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
      toast.success("If that email exists, a reset link has been sent.");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <Toaster position="top-right" />
      <div className="min-h-screen flex items-center justify-center bg-[#F4F4F5] p-8" data-testid="forgot-password-page">
        <div className="w-full max-w-sm">
          <div className="flex items-center gap-2.5 mb-10">
            <img src="/brand/kanal-logo.svg" alt="Kanal" className="h-10 w-10" />
            <div className="font-semibold text-lg" style={{ fontFamily: "Work Sans" }}>
              Kanal
            </div>
          </div>

          <h1 className="text-3xl font-semibold tracking-tight mb-2" style={{ fontFamily: "Work Sans" }}>
            Forgot password
          </h1>
          <p className="text-sm text-zinc-500 mb-8">
            Enter your email and we'll send a reset link.
          </p>

          {sent ? (
            <div className="bg-white border border-zinc-200 rounded-md p-6 text-sm" data-testid="reset-sent">
              <div className="font-semibold text-zinc-900 mb-1">Check your inbox</div>
              <div className="text-zinc-600">If an account with <b>{email}</b> exists, you'll receive a reset link shortly.</div>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="forgot-form">
              <div>
                <Label className="text-xs font-semibold uppercase tracking-wider text-zinc-600">Email</Label>
                <Input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="you@company.com"
                  className="mt-1.5"
                  data-testid="forgot-email-input"
                />
              </div>
              <Button
                type="submit"
                disabled={submitting}
                className="w-full bg-[#002BF6] hover:bg-[#0021C7] text-white h-10"
                data-testid="forgot-submit-btn"
              >
                {submitting ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          )}

          <Link
            to="/login"
            className="mt-6 inline-flex items-center gap-1 text-xs font-semibold text-zinc-500 hover:text-zinc-900"
            data-testid="back-to-login"
          >
            <ArrowLeft size={12} /> Back to sign in
          </Link>
        </div>
      </div>
    </>
  );
}
